export default {
	computed: {
		isAppsEmployeeLoggedIn() {
			return this.$store.getters.getAppsEmployeeLoginStatus;
		},
		getAppsEmployeeDamageCase() {
			return this.$store.getters.getAppsEmployeeDamageCase;
		},
		isRepairProofExists() {
			return this.getAppsEmployeeDamageCase && this.getAppsEmployeeDamageCase.repairProof !== null;
		},
	},
	methods: {
		clearSession() {
			this.$store.commit('setAppsEmployeeDamageCase', null);
			this.$store.commit('setAppsEmployeeLoginStatus', false);
			this.$store.commit('setAppsEmployeeLoginStatusCode', null);
		},
		logout() {
			this.clearSession();
			this.$router.push({ name: 'AppsEmployeeStart' });
		},
	},
};
